








import { Component, Model, Vue } from 'vue-property-decorator';
import { backgrounds } from '../configs/backgrounds';

@Component({})
export default class Background extends Vue {
  @Model() private internalBackground: string = backgrounds[Math.floor(Math.random() * backgrounds.length)];

  /**
   * Formatted background css style.
   * @returns {string}
   */
  get currentBackground(): string {
    return `url(${this.internalBackground}) no-repeat center center fixed`;
  }
}
